<template>
<div class="d-lottie-loader">
    <DLottie @complete="complete" @loaded="loaded" :size="size" :autoplay="autoplay" :loop="loop" :src="loader_src"></DLottie>
</div>
</template>

<script setup>

import { defineProps, defineEmits } from 'vue';
const emit = defineEmits(['complete', 'loaded'])

import DLottie from './LottieComponent.vue'
import lootieicons from '../../enums/dlottie';

const props = defineProps({
    size: { type: Number},
    loop: { type: Boolean, default: true },
    autoplay: { type: Boolean, default: true },
    name :{ type:String, default: "default"},
    link: { type: String, default: null}
})  

const loader_src =  props.link ? props.link :JSON.parse(lootieicons.loader[props.name]);

function complete(){
    emit("complete");
}

function loaded(){
    emit("loaded");
}
</script>
